import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ClosedCaptionOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"closed_caption_off"}/>
}
